//* 组件库
import type { UiTableOption2 } from "various-ui";
export const useOptions = () => {
    //* 插件
    const i18n = useI18n();

    return {
        info: <UiTableOption2[]>[
            { key: "methods", name: i18n.t("Inheritance"), align: "center" },
            { key: "onset", name: i18n.t("AgeOnset"), align: "center" },
            { key: "prevalence", name: i18n.t("Prevalence"), align: "center", explain: i18n.t("PrevalenceExplain") },
            { key: "genes", name: i18n.t("Layout.TypeRelated", { type: "Gene" }), align: "center" },
            { key: "models", name: i18n.t("RelatedModels"), align: "center" },
            { key: "references", name: i18n.t("Reference"), align: "center" },
            { key: "malacard", name: i18n.t("Malacard"), align: "center" },
        ],
    };
};
